import { ActionTree } from 'vuex';
import { UndergradSubmoduleState } from '@/store/undergrad/submodules/state';
import RootState from '@/store/root_state';
import { ErrorHandler } from '@/helpers/errorHandler';
import i18n from '@/i18n';
import { SubmodulesReaderService } from '@/services/undergrad/submodules-reader.service';
import { UndergradModule } from '@/models/undergrad/undergrad-module.model';
import { undergradSubmodules } from '../undergrad_api_normalizr_schema';
import { normalize } from 'normalizr';

const actions: ActionTree<UndergradSubmoduleState, RootState> = {
  async PULL_USER_UNDERGRAD_SUBMODULES_BY_COURSE({ commit }, courseId: string) {
    try {
      const submodules: UndergradModule[] = await SubmodulesReaderService.getSubmodules(courseId);

      const normalizedResponse = normalize(submodules, [undergradSubmodules]);

      commit('SET_UNDERGRAD_SUBMODULES', normalizedResponse.entities);
    } catch (error) {
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.t('itWasNotPossibleToUpdateStudentScore').toString(),
      });
    }
  },
};

export default actions;
